import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-field-error-display',
  templateUrl: './field-error-display.component.html',
  styleUrls: ['./field-error-display.component.scss'],
  standalone: false,
})

/**
 * When there is an error in the form, this hightlights the field and shows the error under the field
 */
export class FieldErrorDisplayComponent {
  /**
   * The error message to show
   */
  @Input() errorMessage?: string;

  /**
   * Whether or not the error should be shown
   */
  @Input() shouldDisplayError?: boolean;
}
